const bidcode = {
      code1: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 远程异地项目登记依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>   \n   <artifactId>cebpubservice-remotebidevaluation-java-sdk-projectregistration</artifactId>
      <version>x.x.x(点击查看最新版本号2)</version>
</dependency>`,
      code2: `import com.cebpubservice.remotebidevaluation.sdk.projectregistration.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class ProjectRegistrationConfig {
    // 远程异地评标目录服务组件地址，由省市区县交易中心等部署远程异地评标目录服务组件前置机方提供\n`
            + '   @Value("${serviceUrl}")\n'
            + '   private String serviceUrl;\n'
            + '   // 电子交易系统编码，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子交易系统页面取\n'
            + '   @Value("${tradingSystemCode}")\n'
            + '   private String tradingSystemCode;\n'
            + '   // 用于电子交易系统集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子交易系统页面获取\n'
            + '   @Value("${clientId}")\n'
            + '   private String clientId;\n'
            + '   // 用于电子交易系统集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子 交易系统页面获取\n'
            + '   @Value("${clientSecret}")\n'
            + '  private String clientSecret;\n'
            + ' // 用于电子交易系统集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子交易系统页面获取\n'
            + ' @Value("${signatureSecret}")\n'
            + ' private String signatureSecret;\n'

            + `  @PostConstruct
     public void initProjectRegistration(){
     //确保此方法只在初始化时执行一次
     ProjectRegistrationSingleton.init(tradingSystemCode, serviceUrl, clientId, clientSecret, signatureSecret);
    }
}`,
      code3: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 远程异地项目开标依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>\n      <artifactId>cebpubservice-remotebidevaluation-java-sdk-projectbidopening</artifactId>
      <version>x.x.x(点击查看最新版本号3)</version>
</dependency>`,
      code4: `import com.cebpubservice.remotebidevaluation.sdk.projectbidopening.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class ProjectBidOpeningConfig {
    // 远程异地评标目录服务组件地址，由省市区县交易中心等部署远程异地评标目录服务组件前置机方提供\n`
            + '  @Value("${serviceUrl}")\n'
            + '  private String serviceUrl;\n'
            + '  // 电子交易系统编码，通过远程异地评标和评标专家库共享管理终端设置电子交易系统页面获取\n'
            + '  @Value("${tradingSystemCode}")\n'
            + '  private String tradingSystemCode;\n'
            + '  // 用于电子交易系统集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子交易系统页面获取\n'
            + '  @Value("${clientId}")\n'
            + '  private String clientId;\n'
            + '  // 用于电子交易系统集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子交易系统页面获取\n'
            + '  @Value("${clientSecret}")\n'
            + '  private String clientSecret;\n'
            + '  // 用于电子交易系统集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子交易系统页面获取\n'
            + '  @Value("${signatureSecret}")\n'
            + `    private String signatureSecret;
    
    @PostConstruct
    public void initProjectBidOpening(){
        //确保此方法只在初始化时执行一次
      ProjectBidOpeningSingleton
.init(tradingSystemCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}
    `,
      code5: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
       <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 远程异地项目评标依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>\n      <artifactId>cebpubservice-remotebidevaluation-java-sdk-projectevaluation</artifactId>
      <version>x.x.x(点击查看最新版本号4)</version>
</dependency>`,
      code6: `import com.cebpubservice.remotebidevaluation.sdk.projectevaluation.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class ProjectEvaluationConfig {
    // 远程异地评标目录服务组件地址，由省市区县交易中心等部署远程异地评标目录服务组件前置机方提供\n`

            + '    @Value("${serviceUrl}")\n'
            + '   private String serviceUrl;\n'
            + '   // 电子交易系统编码，通过远程异地评标和评标专家库共享管理终端设置电子交易系统页面获取\n'
            + '   @Value("${tradingSystemCode}")\n'
            + '   private String tradingSystemCode;\n'
            + '  // 用于电子交易系统集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子交易系统页面获取\n'
            + '    @Value("${clientId}")\n'
            + '    private String clientId;\n'
            + '   // 用于电子交易系统集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子交易系统页面获取\n'
            + '   @Value("${clientSecret}")\n'
            + '   private String clientSecret;\n'
            + '    // 用于交易系统集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子交易系统页面获取\n'
            + '   @Value("${signatureSecret}")\n'
            + `   private String signatureSecret;
    
    @PostConstruct
    public void initProjectEvaluation(){
        //确保此方法只在初始化时执行一次
      ProjectEvaluationSingleton
.init(tradingSystemCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,
      code7: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 远程异地项目归集归档依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>   \n   <artifactId>cebpubservice-remotebidevaluation-java-sdk-projectcollectionandarchiving</artifactId>
      <version>x.x.x(点击查看最新版本号5)</version>
</dependency>
`,
      code8: `import com.cebpubservice.remotebidevaluation.sdk.projectcollectionandarchiving.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class ProjectCollectionAndArchivingConfig {
    // 远程异地评标目录服务组件地址，由省市区县交易中心等部署远程异地评标目录服务组件前置机方提供\n`
            + '     @Value("${serviceUrl}")\n'
            + '     private String serviceUrl;\n'
            + '    // 电子交易系统编码，通过远程异地评标和评标专家库共享管理终端设置电子交易系统页面获取\n'
            + '    @Value("${tradingSystemCode}")\n'
            + '    private String tradingSystemCode;\n'
            + '    // 用于电子交易系统集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子交易系统页面获取\n'
            + '     @Value("${clientId}")\n'
            + '    private String clientId;\n'
            + '    // 用于电子交易系统集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子交易系统页面获取\n'
            + '   @Value("${clientSecret}")\n'
            + '    private String clientSecret;\n'
            + '    // 用于交易系统集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子交易系统页面获取\n'
            + '    @Value("${signatureSecret}")\n'
            + `  private String signatureSecret;
    
    @PostConstruct
    public void initProjectCollectionAndArchiving(){
        //确保此方法只在初始化时执行一次
      ProjectCollectionAndArchivingSingleton
.init(tradingSystemCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,
      code9: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 项目评标依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>    \n      <artifactId>cebpubservice-remotebidevaluation-java-sdk-projectbidevaluation</artifactId>
      <version>x.x.x(点击查看最新版本号6)</version>
</dependency>`,
      code10: `import com.cebpubservice.remotebidevaluation.sdk.projectbidevaluation.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class ProjectBidEvaluationConfig {
    // 远程异地评标目录服务组件地址，由省市交易中心等部署远程异地评标与评标专家库共享目录服务组件自助管理终端服务前置机方提供\n`
            + '    @Value("${serviceUrl}")\n'
            + '     private String serviceUrl;\n'
            + '     // 电子评标工具编码，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子评标工具页面获取\n'
            + '     @Value("${evaluationToolCode}")\n'
            + '     private String evaluationToolCode;\n'
            + '     // 用于电子评标工具集成SDK时设置，可通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子评标工具页面获取\n'
            + '     @Value("${clientId}")\n'
            + '     private String clientId;\n'
            + '     // 用于电子评标工具集成SDK时设置，可通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子评标工具页面获取\n'
            + '     @Value("${clientSecret}")\n'
            + '     private String clientSecret;	\n'
            + '     // 用于电子评标工具集成SDK时设置，可通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置电子评标工具页面获取\n'
            + '     @Value("${signatureSecret}")\n'
            + ` private String signatureSecret;
    
    @PostConstruct
    public void initProjectBidEvaluation(){
        //确保此方法只在初始化时执行一次
      ProjectBidEvaluationSingleton
.init(evaluationToolCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,
      code11: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 场所工位信息同步依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>   \n   <artifactId>cebpubservice-remotebidevaluation-java-sdk-seatsync</artifactId>
      <version>x.x.x(点击查看最新版本号7)</version>
</dependency>`,
      code12: `import com.cebpubservice.remotebidevaluation.sdk.seatsync.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class SeatSyncConfig {
    // 远程异地评标和评标专家库共享管理终端服务地址，由省市区县交易中心等部署远程异地评标和评标专家库共享目录服务组件自助管理终端服务前置机方提供\n`
            + '    @Value("${serviceUrl}")\n'
            + '    private String serviceUrl;\n'
            + '     // 场地管理系统编码，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地管理系统页面获取\n'
            + '     @Value("${siteManagementSystemCode}")\n'
            + '     private String siteManagementSystemCode;\n'
            + '     // 场地管理系统集成SDK时设置，可通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地管理系统页面获取\n'
            + '     @Value("${clientId}")\n'
            + '     private String clientId;\n'
            + '     // 场地管理系统集成SDK时设置，可通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地管理系统页面获取\n'
            + '    @Value("${clientSecret}")\n'
            + '     private String clientSecret;\n'
            + '     // 用场地管理系统集成SDK时设置，可通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地管理系统页面获取\n'
            + '     @Value("${signatureSecret}")\n'
            + `  private String signatureSecret;
    
    @PostConstruct
    public void initSeatSync(){
        //确保此方法只在初始化时执行一次
      SeatSyncSingleton
.init(siteManagementSystemCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,
      code13: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 远程异地场所工位预约结果依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>   \n   <artifactId>cebpubservice-remotebidevaluation-java-sdk-placeseatreservationresult</artifactId>
      <version>x.x.x(点击查看最新版本号8)</version>
</dependency>`,
      code14: `import com.cebpubservice.remotebidevaluation.sdk.placeseatreservationresult.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class PlaceSeatReservationResultConfig {
    // 远程异地评标目录服务组件地址，由省市区县交易中心等部署远程异地评标目录服务组件前置机方提供\n`
            + '     @Value("${serviceUrl}")\n'
            + '     private String serviceUrl;\n'
            + '     // 场地管理系统编码，通过远程异地评标和评标专家库共享管理终端设置场地管理系统页面获取\n'
            + '     @Value("${siteManagementSystemCode}")\n'
            + '     private String siteManagementSystemCode;\n'
            + '     // 用于场地管理系统集成SDK时设置，可通过远程异地评标和评标专家库共享管理终端设置场地管理系统页面获取\n'
            + '     @Value("${clientId}")\n'
            + '     private String clientId;\n'
            + '     // 用于场地管理系统集成SDK时设置，可通过远程异地评标和评标专家库共享管理终端设置场地管理系统页面获取\n'
            + '     @Value("${clientSecret}")\n'
            + '     private String clientSecret;\n'
            + '     // 用于场地管理系统集成SDK时设置，可通过远程异地评标和评标专家库共享管理终端设置场地管理系统页面获取\n'
            + '     @Value("${signatureSecret}")\n'
            + `  private String signatureSecret;
  
    @PostConstruct
    public void initPlaceSeatReservationResult(){
        //确保此方法只在初始化时执行一次
      PlaceSeatReservationResultSingleton
.init(siteManagementSystemCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,
      code15: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 查询设置开通目录依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>    \n  <artifactId>cebpubservice-remotebidevaluation-java-sdk-getsetopendirectory</artifactId>
      <version>x.x.x(点击查看最新版本号9)</version>
</dependency>
`,

      code16: `import com.cebpubservice.remotebidevaluation.sdk.getsetopendirectory.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class GetSetOpenDirectoryConfig  {
    // 远程异地评标目录服务组件地址，由省市交易中心等部署远程异地评标与评标专家库共享目录服务组件自助管理终端服务前置机方提供\n`
            + '     @Value("${serviceUrl}")\n'
            + '     private String serviceUrl;\n'
            + '     // 远程异地评标项目登记工具编码，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置远程异地评标项目登记工具页面获取\n'
            + '     @Value("${remoteBidEvaluationProjectRegistrationToolCode}")\n'
            + '    private String remoteBidEvaluationProjectRegistrationToolCode;\n'
            + '    // 用于远程异地评标项目登记工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置远程异地评标项目登记工具页面获取\n'
            + '     @Value("${clientId}")\n'
            + '     private String clientId;\n'
            + '     // 用于远程异地评标项目登记工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置远程异地评标项目登记工具页面获取\n'
            + '     @Value("${clientSecret}")\n'
            + '    private String clientSecret;	\n'
            + '     // 用于远程异地评标项目登记工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置远程异地评标项目登记工具页面获取\n'
            + '     @Value("${signatureSecret}")\n'
            + `  private String signatureSecret;
    
    @PostConstruct
    public void initSetOpenDirectory(){
        //确保此方法只在初始化时执行一次
      GetSetOpenDirectorySingleton
.init(remoteBidEvaluationProjectRegistrationToolCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,
      code17: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 远程异地项目登记依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>\n      <artifactId>cebpubservice-remotebidevaluation-java-sdk-projectregistration</artifactId>
      <version>x.x.x(点击查看最新版本号10)</version>
</dependency>
`,
      code18: `import com.cebpubservice.remotebidevaluation.sdk.projectregistration.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class ProjectRegistrationConfig {
    // 远程异地评标目录服务组件地址，由省市交易中心等部署远程异地评标与评标专家库共享目录服务组件自助管理终端服务前置机方提供 \n`
            + '    @Value("${serviceUrl}")\n'
            + '    private String serviceUrl;\n'
            + '    // 远程异地评标项目登记工具编码，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置远程异地评标项目登记工具页面获取\n'
            + '     @Value("${remoteBidEvaluationProjectRegistrationToolCode}")\n'
            + '     private String remoteBidEvaluationProjectRegistrationToolCode;\n'
            + '    // 用于远程异地评标项目登记工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置远程异地评标项目登记工具页面获取\n'
            + '     @Value("${clientId}")\n'
            + '     private String clientId;\n'
            + '    // 用于远程异地评标项目登记工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置远程异地评标项目登记工具页面获取\n'
            + '     @Value("${clientSecret}")\n'
            + '     private String clientSecret;	\n'
            + '    // 用于远程异地评标项目登记工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置远程异地评标项目登记工具页面获取\n'
            + '     @Value("${signatureSecret}")\n'
            + `  private String signatureSecret;
    
    @PostConstruct
    public void initProjectRegistration(){
        //确保此方法只在初始化时执行一次
      RProjectRegistrationSingleton
.init(remoteBidEvaluationProjectRegistrationToolCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,
      code19: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 远程异地项目归集归档依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>   \n   <artifactId>cebpubservice-remotebidevaluation-java-sdk-projectcollectionandarchiving</artifactId>
      <version>x.x.x(点击查看最新版本号5)</version>
</dependency>`,
      code20: `import com.cebpubservice.remotebidevaluation.sdk.projectcollectionandarchiving.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class ProjectCollectionAndArchivingConfig {
    // 远程异地评标目录服务组件地址，由省市交易中心等部署远程异地评标与评标专家库共享目录服务组件自助管理终端服务前置机方提供\n`
            + '    @Value("${serviceUrl}")\n'
            + '     private String serviceUrl;\n'
            + '     // 远程异地评标项目登记工具编码，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置远程异地评标项目登记工具页面获取\n'
            + '     @Value("${remoteBidEvaluationProjectRegistrationToolCode}")\n'
            + '     private String remoteBidEvaluationProjectRegistrationToolCode;\n'
            + '     // 用于远程异地评标项目登记工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置远程异地评标项目登记工具页面获取\n'
            + '     @Value("${clientId}")\n'
            + '     private String clientId;\n'
            + '     // 用于远程异地评标项目登记工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置远程异地评标项目登记工具页面获取\n'
            + '    @Value("${clientSecret}")\n'
            + '     private String clientSecret;	\n'
            + '     // 用于远程异地评标项目登记工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置远程异地评标项目登记工具页面获取\n'
            + '     @Value("${signatureSecret}")\n'
            + ` private String signatureSecret;
    
    @PostConstruct
    public void initProjectCollectionAndArchiving(){
        //确保此方法只在初始化时执行一次
      ProjectCollectionAndArchivingSingleton
.init(remoteBidEvaluationProjectRegistrationToolCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,
      code21: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 查询设置开通目录依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId> \n     <artifactId>cebpubservice-remotebidevaluation-java-sdk-getsetopendirectory</artifactId>
      <version>x.x.x(点击查看最新版本号9)</version>
</dependency>
`,
      code22: `import com.cebpubservice.remotebidevaluation.sdk.getsetopendirectory.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class GetSetOpenDirectoryConfig {
    // 远程异地评标目录服务组件地址，由省市交易中心等部署远程异地评标与评标专家库共享目录服务组件自助管理终端服务前置机方提供\n`
            + '    @Value("${serviceUrl}")\n'
            + '    private String serviceUrl;\n'
            + '    // 远场所工位预约工具编码，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场所工位预约工具页面获取\n'
            + '    @Value("${placeSeatReservationToolCode}")\n'
            + '    private String placeSeatReservationToolCode;\n'
            + '    // 用于场所工位预约工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场所工位预约工具页面获取\n'
            + '     @Value("${clientId}")\n'
            + '    private String clientId;\n'
            + '    // 用于场所工位预约工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场所工位预约工具页面获取\n'
            + '     @Value("${clientSecret}")\n'
            + '     private String clientSecret;	\n'
            + '     // 用于场所工位预约工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场所工位预约工具页面获取\n'
            + '     @Value("${signatureSecret}")\n'
            + `     private String signatureSecret;
    
    @PostConstruct
    public void initSetOpenDirectory(){
        //确保此方法只在初始化时执行一次
      GetSetOpenDirectoryConfig 
.init(placeSeatReservationToolCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,
      code23: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 场所工位预约申请依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId> \n     <artifactId>cebpubservice-remotebidevaluation-java-sdk-placeseatreservationapply</artifactId>
      <version>x.x.x(点击查看最新版本号11)</version>
</dependency>`,
      code24: `import com.cebpubservice.remotebidevaluation.sdk.placeseatreservationapply.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class PlaceSeatReservationApplyConfig {
    // 远程异地评标目录服务组件地址，由省市交易中心等部署远程异地评标与评标专家库共享目录服务组件自助管理终端服务前置机方提供\n`
            + '    @Value("${serviceUrl}")\n'
            + '    private String serviceUrl;\n'
            + '    // 场所工位预约工具编码，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场所工位预约工具页面获取\n'
            + '    @Value("${placeSeatReservationToolCode}")\n'
            + '    private String placeSeatReservationToolCode;\n'
            + '    // 用于场所工位预约工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场所工位预约工具页面获取\n'
            + '    @Value("${clientId}")\n'
            + '    private String clientId;\n'
            + '    // 用于场所工位预约工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场所工位预约工具页面获取\n'
            + '    @Value("${clientSecret}")\n'
            + '    private String clientSecret;	\n'
            + '    // 用于场所工位预约工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场所工位预约工具页面获取\n'
            + '    @Value("${signatureSecret}")\n'
            + `    private String signatureSecret;
    
    @PostConstruct
    public void initPlaceSeatReservationApply(){
        //确保此方法只在初始化时执行一次
      PlaceSeatReservationApplySingleton
.init(placeSeatReservationToolCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,
      code25: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 场地专家签到依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId> \n     <artifactId>cebpubservice-remotebidevaluation-java-sdk-placeexpertcheckin</artifactId>
      <version>x.x.x(点击查看最新版本号12)</version>
</dependency>`,
      code26: `import com.cebpubservice.remotebidevaluation.sdk.placeexpertcheckin.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
@Configuration
public class PlaceExpertCheckInConfig {
// 远程异地评标目录服务组件地址，由省市交易中心等部署远程异地评标与评标专家库共享目录服务组件自助管理终端服务前置机方提供\n`
            + '    @Value("${serviceUrl}")\n'
            + '    private String serviceUrl;\n'
            + '    // 场地专家签到工作台编码，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地专家签到工作台页面获取\n'
            + '    @Value("${placeExpertCheckInToolCode}")\n'
            + '    private String placeExpertCheckInToolCode;\n'
            + '    // 用于场地专家签到工作台集成 SDK 时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地专家签到工作台页面获取\n'
            + '    @Value("${clientId}")\n'
            + '    private String clientId;\n'
            + '    // 用于场地专家签到工作台集成 SDK 时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地专家签到工作台页面获取\n'
            + '    @Value("${clientSecret}")\n'
            + '    private String clientSecret;\n'
            + '    // 用于场地专家签到工作台集成 SDK 时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地专家签到工作台页面获取\n'
            + '    @Value("${signatureSecret}")\n'
            + ` private String signatureSecret;
@PostConstruct
public void initPlaceExpertCheckInApply(){
//确保此方法只在初始化时执行一次
PlaceExpertCheckInSingleton
.init(placeExpertCheckInToolCode,serviceUrl,clientId,clientSecret,signatureSecret);
  }
}`,
      code27: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 分配专家物理工位依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-remotebidevaluation-java-sdk-assignexpertphysicalseat</artifactId>
      <version>x.x.x(点击查看最新版本号13)</version>
</dependency>`,
      code28: `import com.cebpubservice.remotebidevaluation.sdk.assignexpertphysicalseat.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class AssignExpertPhysicalSeatConfig {
    // 远程异地评标目录服务组件地址，由省市交易中心等部署远程异地评标与评标专家库共享目录服务组件自助管理终端服务前置机方提供\n`
            + '    @Value("${serviceUrl}")\n'
            + '    private String serviceUrl;\n'
            + '    // 场地专家签到工作台编码，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地专家签到工作台页面获取\n'
            + '    @Value("${placeExpertCheckInToolCode}")\n'
            + '    private String placeExpertCheckInToolCode;\n'
            + '    // 用于场地专家签到工作台集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地专家签到工作台页面获取\n'
            + '    @Value("${clientId}")\n'
            + '    private String clientId;\n'
            + '    // 用于场地专家签到工作台集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地专家签到工作台页面获取\n'
            + '    @Value("${clientSecret}")\n'
            + '    private String clientSecret;\n'
            + '    // 用于场地专家签到工作台集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地专家签到工作台页面获取\n'
            + '    @Value("${signatureSecret}")\n'
            + `    private String signatureSecret;
    
    @PostConstruct
    public void initAssignExpertPhysicalSeat(){
        //确保此方法只在初始化时执行一次
      AssignExpertPhysicalSeatSingleton
.init(placeExpertCheckInToolCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,
      code29: `<!-- 核心包依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId>
      <artifactId>cebpubservice-java-sdk-core</artifactId>
      <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!-- 场地专家评标登录依赖 -->
<dependency>
      <groupId>com.cebpubservice.remotebidevaluation</groupId> \n     <artifactId>cebpubservice-remotebidevaluation-java-sdk-placeexpertbidevaluationlogin</artifactId>
      <version>x.x.x(点击查看最新版本号6)</version>
</dependency>`,
      code30: `import com.cebpubservice.remotebidevaluation.sdk.placeexpertbidevaluationlogin.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;
 
@Configuration
public class PlaceExpertBidEvaluationLoginConfig {
    // 远程异地评标目录服务组件地址，由省市交易中心等部署远程异地评标与评标专家库共享目录服务组件自助管理终端服务前置机方提供\n`
            + '    @Value("${serviceUrl}")\n'
            + '     private String serviceUrl;\n'
            + '     // 场地专家评标登录工作台编码，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地专家评标登录工作台页面获取\n'
            + '     @Value("${placeExpertBidEvaluationLoginToolCode}")\n'
            + '     private String placeExpertBidEvaluationLoginToolCode;\n'
            + '     // 用于场地专家评标登录工作台集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地专家评标登录工作台页面获取\n'
            + '     @Value("${clientId}")\n'
            + '    private String clientId;\n'
            + '    // 用于场地专家评标登录工作台集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地专家评标登录工作台页面获取\n'
            + '    @Value("${clientSecret}")\n'
            + '    private String clientSecret;	\n'
            + '     // 用于场地专家评标登录工作台集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置场地专家评标登录工作台页面获取\n'
            + '     @Value("${signatureSecret}")\n'
            + `   private String signatureSecret;
    
    @PostConstruct
    public void initPlaceExpertBidEvaluationLogin(){
        //确保此方法只在初始化时执行一次
      PlaceExpertBidEvaluationLoginSingleton
.init(placeExpertBidEvaluationLoginToolCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,
      code31: `<!--核心包依赖-->
<dependency>
    <groupId>com.cebpubservice.remotebidevaluation</groupId>
    <artifactId>cebpubservice-java-sdk-core</artifactId>
    <version>x.x.x(点击查看最新版本号1)</version>
</dependency>
<!--专家库共享抽取目录服务组件SDK-->
<dependency>
    <groupId> com.cebpubservice.remotebidevaluation</groupId>
    <artifactId>cebpubservice-remotebidevaluation-java-sdk-component-expertlibraryshareextract</artifactId>
    <version>x.x.x(点击查看最新版本号14)</version>	
</dependency>
`,
      code32: `import com.cebpubservice.remotebidevaluation.sdk.component.expertlibraryshareextract.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;

@Configuration
public class ExpertLibraryShareExtractConfig {
// 评标专家库目录服务组件服务地址，省市区县交易中心等部署评标专家库共享抽取组件前置机方提供   \n`
            + '    @Value("${serviceUrl}")	\n'
            + '    private String serviceUrl;\n'

            + '     //专家库共享抽取工具编码，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置专家库共享抽取工具页面获取\n'
            + '      @Value("${expertLibraryShareExtractToolCode}")\n'
            + '     private String expertLibraryShareExtractToolCode;\n'

            + '       // clientId 用于专家库共享抽取工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置专家库共享抽取工具页面获取\n'
            + '     @Value("${clientId}")\n'
            + '     private String clientId;\n'

            + '     // clientSecret 用于专家库共享抽取工具集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置专家库共享抽取工具页面获取\n'
            + '      @Value("${clientSecret}")\n'
            + '      private String clientSecret;\n'

            + '     // signatureSecret 用于专家库共享抽取工具集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置专家库共享抽取工具页面获取\n'
            + '      @Value("${signatureSecret}")\n'
            + `     private String signatureSecret;

    @PostConstruct
    public void initExpertLibraryShareExtract(){
        //确保此方法只在初始化时执行一次
ExpertLibraryShareExtractSingleton.init(expertLibraryShareExtractToolCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,
code33:`<!--查询设置开通目录SDK-->
<dependency>
    <groupId> com.cebpubservice.remotebidevaluation</groupId>
    <artifactId>cebpubservice-remotebidevaluation-java-sdk-getsetopendirectory</artifactId>
    <version>x.x.x(点击查看最新版本号9)</version>	
</dependency>
<!--核心包依赖-->
<dependency>
    <groupId>com.cebpubservice.remotebidevaluation</groupId>
    <artifactId>cebpubservice-java-sdk-core</artifactId>
    <version>x.x.x(点击查看最新版本号1)</version>`,
code34:`import com.cebpubservice.remotebidevaluation.sdk.getsetopendirectory.*;
import org.springframework.beans.factory.annotation.Value;
import org.springframework.context.annotation.Configuration;
import javax.annotation.PostConstruct;

@Configuration
public class GetSetOpenDirectoryConfig {
//远程异地评标目录服务组件地址，由省市交易中心等部署远程异地评标与评标专家库共享目录服务组件自助管理终端服务前置机方提供
@Value("\${serviceUrl}")	
private String serviceUrl;

    //专家库共享抽取工具编码，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置专家库共享抽取工具页面获取
    @Value("\${expertLibraryShareExtractToolCode}")
    private String expertLibraryShareExtractToolCode;

    // clientId 用于专家库共享抽取工具集成SDK时设置，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置专家库共享抽取工具页面获取
    @Value("\${clientId}")
    private String clientId;

    // clientSecret 用于专家库共享抽取工具集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置专家库共享抽取工具页面获取
    @Value("\${clientSecret}")
    private String clientSecret;

    // signatureSecret 用于专家库共享抽取工具集成SDK时设定，通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置专家库共享抽取工具页面获取
    @Value("\${signatureSecret}")
    private String signatureSecret;

    @PostConstruct
    public void initGetSetOpenDirectory(){
        //确保此方法只在初始化时执行一次
GetSetOpenDirectorySingleton.init(expertLibraryShareExtractToolCode,serviceUrl,clientId,clientSecret,signatureSecret);
    }
}`,

}


export default bidcode
